// extracted by mini-css-extract-plugin
export const form = "contact-form-module--form--16-DM";
export const formGroup = "contact-form-module--formGroup--3amVy";
export const submitButton = "contact-form-module--submitButton--7-uNT";